import { Typography, Box, Grid } from "@mui/material";
import React, { useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import RefreshIcon from "../../assets/icons/RefreshIcon.png";
import DeleteIcon from "../../assets/icons/DeleteIcon.png";
import FileUploadDark from "../../assets/icons/FileUploadDark.png";
import CheckCircle from "../../assets/icons/CheckCircle.png";
import { useTranslation } from "react-i18next";

const StatusQuoFileupload = () => {
  const { t } = useTranslation();
  const [testament, setTestament] = useState("");
  const [custodyOrder, setCustodyoder] = useState("");
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography variant="h5">{t("sidebar-2-text-1")}</Typography>
      <Typography variant="p">{t("sq-upload-docs")}</Typography>
      <Box
        component="div"
        width="100%"
        padding="4rem"
        sx={{
          display: "flex",
        }}
      >
        <Box component="div" width="50%">
          <Box
            compoment="div"
            sx={{ display: "flex", alignItems: "center" }}
            padding="1rem 0"
          >
            <Box component="div" width="50px">
              <img src={RefreshIcon} />
            </Box>
            <Box
              component="div"
              sx={{
                position: "relative",
                border: "2px solid",
                borderColor: "color.magentaMid2",
                padding: "0.8rem 2rem",
                borderRadius: "15px",
                width: "400px",
              }}
            >
              <label>{testament ? testament : "Select file"}</label>
              <input
                type="file"
                style={{ opacity: "0", position: "absolute" }}
              />
            </Box>
            <Box component="div" marginLeft="20px">
              <img src={DeleteIcon} />
            </Box>
            <Box component="div" marginLeft="20px">
              <img src={FileUploadDark} style={{ opacity: "0.5" }} />
            </Box>
          </Box>
          <Box
            compoment="div"
            sx={{ display: "flex", alignItems: "center" }}
            padding="1rem 0"
          >
            <Box component="div" width="50px" />
            <Box
              component="div"
              sx={{
                position: "relative",
                border: "2px solid",
                borderColor: "color.magentaMid2",
                padding: "0.8rem 2rem",
                borderRadius: "15px",
                width: "400px",
              }}
            >
              <label>{custodyOrder ? custodyOrder : "Select file"}</label>
              <input
                type="file"
                style={{ opacity: "0", position: "absolute" }}
              />
            </Box>
            <Box component="div" marginLeft="20px">
              <img src={DeleteIcon} />
            </Box>
            <Box component="div" marginLeft="20px">
              <img src={FileUploadDark} />
            </Box>
          </Box>
          <Box
            compoment="div"
            sx={{ display: "flex", alignItems: "center" }}
            padding="1rem 0"
          >
            <Box component="div" width="50px">
              <img src={CheckCircle} />
            </Box>
            <Box
              component="div"
              sx={{
                position: "relative",
                border: "2px solid",
                borderColor: "color.magentaMid2",
                padding: "0.8rem 2rem",
                borderRadius: "15px",
                width: "400px",
              }}
            >
              <label>{testament ? testament : "Select file"}</label>
              <input
                type="file"
                style={{ opacity: "0", position: "absolute" }}
              />
            </Box>
            <Box component="div" marginLeft="20px">
              <img src={DeleteIcon} />
            </Box>
            <Box component="div" marginLeft="20px">
              <img src={FileUploadDark} />
            </Box>
          </Box>
        </Box>
        {/* <Box component="div" width="50%">
          <LinearProgress />
        </Box> */}
      </Box>
    </Box>
  );
};

export default StatusQuoFileupload;
